module.exports = __webpack_public_path__ + "static/scale-model-of-putnam-museum-and-science-center-in-davenport-iowa-a1c1bc31b514dafbe18e1afb35e94a1b.png";